import * as PIXI from "pixi.js"

export default class Tiler {

    private readonly canvas: HTMLCanvasElement;
    private readonly context: CanvasRenderingContext2D | null;

    constructor(width: number, height: number, fill: string) {
        console.log('%c ### Tiler:', 'color: #f0f', width, height, fill);
        this.canvas = document.createElement('canvas');
        this.canvas.width  = width;
        this.canvas.height = height;
        this.context = this.canvas.getContext('2d');

        if (this.context) {
            this.context.fillStyle = fill;
            this.context.fillRect(0, 0, width, height);
        }
    }

    public loadImage(src: string) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin='anonymous';
            img.addEventListener('load', () => resolve(img));
            img.addEventListener('error', (err) => reject(err));
            img.src = src;
        });
    }

    public async drawImage(src: string, dx: number, dy: number, scale = 1) {
        const image = await this.loadImage(src) as HTMLImageElement;
        this.context?.drawImage(image, 0, 0, image.width, image.height, dx, dy, image.width * scale, image.height * scale);
    }

    public async drawImage0(src: string, scale = 1) {
        const image = await this.loadImage(src) as HTMLImageElement;
        const dx = (this.canvas.width  - image.width  * scale) / 2;
        const dy = (this.canvas.height - image.height * scale) / 2;
        this.context?.drawImage(image, 0, 0, image.width, image.height, dx, dy, image.width * scale, image.height * scale);
    }

    public async drawPattern(src: string, repeat = '', scale = 1) {
        const image = await this.loadImage(src) as HTMLImageElement;
        let dx = 0, dy = 0;
        this.context?.drawImage(image, 0, 0, image.width, image.height, dx, dy, image.width * scale, image.height * scale);

        do {
            do {
                this.context?.drawImage(image, 0, 0, image.width, image.height, dx, dy, image.width * scale, image.height * scale);
                dx += image.width * scale;
            }
            while (dx < ('y' === repeat ? 0 : this.canvas.width));
            dx = 0;
            dy += image.height * scale;
        }
        while (dy < ('x' === repeat ? 0 : this.canvas.height));
    }

    public createTiles(maxSize: number): Array<Array<PIXI.Sprite>>
    {
        const COLS = Math.ceil(this.canvas.width  / maxSize);
        const ROWS = Math.ceil(this.canvas.height / maxSize);
        const sizeX = Math.floor(this.canvas.width  / COLS);
        const sizeY = Math.floor(this.canvas.height / ROWS);
        const baseTexture = PIXI.BaseTexture.from(this.canvas);

        const arr2d: Array<Array<PIXI.Sprite>> = [];
        for (let row = 0; row < ROWS; ++row) {
            const arr: Array<PIXI.Sprite> = [];
            for (let col = 0; col < COLS; ++col) {
                const texture = new PIXI.Texture(baseTexture, new PIXI.Rectangle(col * sizeX, row * sizeY, sizeX, sizeY));
                arr.push(new PIXI.Sprite(texture));
            }
            arr2d.push(arr);
        }
        return arr2d;
    }

}
